import React from 'react';
import { connect } from 'react-redux';

import ModelRuleAndRuleView from './ModelRuleAndRuleView';
import { AppState } from '@Redux/store';
import { ModelRuleView } from '@Selectors/builder/myArmyList/make/unit/show/view/ArmyListUnitProfilV2View';
import { UnitCaracView } from '@Selectors/builder/myArmyList/make/unit/show/view/UnitCaracView';
import { UnitCaracType } from '@Models';

interface IUnitGlobalProfilProps {
  armyListUnitId: string;
  carac: UnitCaracView;
  modelRules: Array<ModelRuleView>;
}

const UnitGlobalProfil: React.FC<UnitGlobalProfilProps> = ({ armyListUnitId, carac, modelRules }) => {

  return (
    <div className="col-12">
      <table className="content-stats stats-v2 stats-global">
        <thead>
          <tr>
            <th scope="col">Global</th>
            {carac.type === UnitCaracType.V2 && (
              <>
                <th scope="col" className="text-center">Adv</th>
                <th scope="col" className="text-center">Mar</th>
                <th scope="col" className="text-center">Dis</th>
              </>
            )}
            {carac.type === UnitCaracType.V3 && (
              <>
                <th scope="col" className="text-center">Cha</th>
                <th scope="col" className="text-center">Mob</th>
                <th scope="col" className="text-center">Cou</th>
              </>
            )}
            {carac.evoked && <th scope="col" className="text-center">Evoked</th>}
            <th scope="col" />
            <th scope="col" />
            <th scope="col" className="d-none d-md-block">
              Model Rules
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td className="text-center">{carac.adv}</td>
            <td className="text-center">{carac.mar}</td>
            <td className="text-center">{carac.dis}</td>
            {carac.evoked && <td className="text-center">{carac.evoked}</td>}
            <td />
            <td />
            <td className="d-none d-md-block">
              <ModelRuleAndRuleView
                armyListUnitId={armyListUnitId}
                modelRules={modelRules}
              />
            </td>
          </tr>
          {carac.type === UnitCaracType.V2 && carac.flyAdv && (
            <tr>
              <td>Fly</td>
              <td>{carac.flyAdv}</td>
              <td>{carac.flyMar}</td>
              {carac.evoked && <td />}
              <td colSpan={3} />
              <td className="d-none d-md-block"></td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="d-block d-md-none content-stats">
        <ModelRuleAndRuleView armyListUnitId={armyListUnitId} modelRules={modelRules} />
      </div>
    </div>
  );
};

const mapStateToProps = (
  _: AppState,
  owsProps: IUnitGlobalProfilProps,
) => ({
  armyListUnitId: owsProps.armyListUnitId,
  carac: owsProps.carac,
  modelRules: owsProps.modelRules
    .filter(item => item.isGlobal)
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UnitGlobalProfil);

type UnitGlobalProfilProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
